import { usePanel } from '@hooks/usePanel';
import { useParams } from 'react-router';

export const usePanelUrl = (url: string) => {
  const { panel } = usePanel();
  const { tenantId } = useParams();

  return {
    url: [panel && `tenants/${tenantId}`, url].filter(Boolean).join('/'),
    panel,
  };
};
